import InfiniteLoading from 'vue-infinite-loading';

if ($('#case-studies-list-component').length) {
    var app = new Vue({
        el: '#case-studies-list-component',
        data: {
            loading: true,
            firstLoad: true,
            studies: [],
            page: 1
        },
        methods: {
            getStudies($state) {
                let url = '/case-studies';
                url = url + '?page=' + this.page;

                var scrollPosition = null;
                if (this.firstLoad && sessionStorage.scrollPos && sessionStorage.scrollPos != 0) {
                    scrollPosition = sessionStorage.scrollPos;
                }

                axios.get('/api/v1' + url).then((response) => {
                    if (this.page == 1 && response.data.data.length) {
                        this.studies = response.data.data;
                    } else {
                        this.studies.push.apply(this.studies, response.data.data)
                    }

                    this.loading = false;
                    this.page++;
                    if (this.page > response.data.last_page) {
                        $state.complete();
                    } else {
                        $state.loaded();
                    }

                    if (this.firstLoad) {
                        this.$nextTick(() => {
                            if (scrollPosition) {
                                $(window).scrollTop(scrollPosition)
                            }
                        });
                    }

                    this.firstLoad = false;
                }).catch(function (error) {
                    console.log(error);
                });
            }
        },
        mounted() {
            $(window).scroll(function () {
                sessionStorage.scrollPos = $(window).scrollTop();
            });
        },
        components: {
            InfiniteLoading
        },
    });
}